export const localStorageKeys = {
  localNotifications: 'gp_local_notifications',
  contactLensImageType: 'contactLensImageType',
  contactLensImageTypeSwitcherHintDismissed: 'contactLensImageTypeSwitcherHintDismissed',
  recentlyViewed: 'checked_productclass',
} as const
